import React from 'react';

const Body = ({ children }) => <>{children}</>;

export default Body;
